module.exports = __webpack_public_path__ + "static/media/eva_calendar-filled.d8ee3246.svg";